module.exports = __webpack_public_path__ + "img/snow.42198eb3.png";